import React from "react";
import {
    CartProduct,
    Img,
    Body,
    CartSpan,
    CartButton,
    EmptyContainer,
    Options,
    OptionsContainer
} from "./style";
import Title from "../Title/index";
import Format from "../Format/index";
import { useDispatch } from "react-redux";
import { FetchRemoveCart } from "../../../Actions/cartAction";
import Button from "../Button/index";
import PropTypes from "prop-types";

export default function CartTable({ products, total,onClick }) {
    const dispatch = useDispatch();

    const onRemove = (id) => {
        dispatch(FetchRemoveCart(id));
    };

    return (
        <>
            {products.length === 0 ? (
                <EmptyContainer>
                    <Title>Your cart is Empty</Title>
                    <Button color={"rgba(242, 38, 19, 1)"} ty={"/"}>Back to Store</Button>
                </EmptyContainer>
            ) : (
                <>
                    {products.map((product) => (
                        <CartProduct key={product.id}>
                            <Img src="/svg/Roupas.jpg" />
                            <Body>
                                <CartSpan>{product.title}</CartSpan>
                                <Format price={product.price} />
                                <CartSpan>Qty:{product.qty}</CartSpan>
                                <CartButton
                                    onClick={() => onRemove(product.product)}
                                >
                                    Remove
                                </CartButton>
                            </Body>
                        </CartProduct>
                    ))}
                    <Options>
                        <OptionsContainer flex={"flex-end"}>
                         Total:<Format price={total} />
                        </OptionsContainer>
                        <OptionsContainer flex={"space-between"}>
                        <Button color={"rgba(242, 38, 19, 1)"} ty={"/"}>Back to Store</Button>
                        <Button color={"rgba(0,230,64,1)"} onClick={onClick}  ty={"/Order"}>Confirm</Button>
                        </OptionsContainer>
                    </Options>
                </>
            )}
        </>
    );
}


CartTable.propTypes = {
    products:PropTypes.array,
    total:PropTypes.number,
    onClick:PropTypes.func
};
